import { render } from "./partnersFeature.vue?vue&type=template&id=13f2497c"
import script from "./partnersFeature.vue?vue&type=script&lang=js"
export * from "./partnersFeature.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__